import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import Search from "../Search";
import Login from "../Core/Login";
import Layout from "./Layout";
import { store } from "./Store";
import HistoryListener from "./HistoryListener";
import Events from "../Events";
import MPE from "../Search/MPE";
import PST from "../Search/PST";
import JiraReports from "../JiraReports";
import Customers from "../Customers";
import { injectStore } from "./http";
import NetworkDiagram from "../NetworkDiagram";
import SharedDashboard from "../CustomDashboard/SharedDashboard";

injectStore(store);

function App() {
    return (
        <Provider store={store}>
            <Router>
                <HistoryListener>
                    <Fragment>
                        <Login>
                            <Layout>
                                <Routes>
                                    <Route path="/" element={<Search />} />
                                    <Route path="/search" element={<Search />} />
                                    <Route path="/events" element={<Events />} />
                                    <Route path="/pstSearch" element={<PST />} />
                                    <Route path="/mpeSearch" element={<MPE />} />
                                    <Route path="/jiraReports" element={<JiraReports />} />
                                    <Route path="/jiraReports/:search" element={<JiraReports />}/>
                                    <Route path="/customers" element={<Customers />} />
                                    <Route path="/customers/:search" element={<Customers />} />
                                    <Route path="/networkDiagram" element={<NetworkDiagram />} />
                                    <Route path="/networkDiagram/:search" element={<NetworkDiagram />}/>
                                    <Route path="/sharedDashboard" element={<SharedDashboard />} />
                                    <Route path="/sharedDashboard/:queryparams" element={<SharedDashboard />} />
                                </Routes>
                            </Layout>
                        </Login>
                    </Fragment>
                </HistoryListener>
            </Router>
        </Provider>
    );
}

export default App;
